const initialState = {};

// this
export function BackListReducer(state = initialState, action) {
  switch (action?.type) {
    case 'PLACED_ORDER_INFO':
      return {
        ...state,
        placedOrderInfo: action?.payload,
      };

    default:
      return state;
  }
}
